module.exports = __webpack_public_path__ + "static/media/doctor-09.9776cc55.jpg";